/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ValidationArguments } from './validation-arguments.model';

export interface ValidationErrorData {
  validationKey?: string;  // (e.g., kit-core/validation/required, ...)
  validationArguments?: ValidationArguments;
}

export class ValidationError {
  readonly validationKey: string;
  readonly validationArguments: ValidationArguments;

  constructor(validationError: ValidationErrorData) {
    this.validationKey = validationError.validationKey;
    this.validationArguments = validationError.validationArguments;
  }

  toJSON(): ValidationErrorData {
    return {
      validationKey: this.validationKey,
      validationArguments: this.validationArguments
    };
  }
}
